import { ActionTypes } from '../../constants/ActionTypes';
import { IAttachment } from '../../interfaces';

const INIT_STATE: IAttachment = {
  attachments: [],
  letterCode: '',
  letterAttachmentUploadModel: [],
  downloadAttachment: null,
  loadingToRequest: false,
  upLoadedAttachment: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_Attachment_SUCCESS: {
      return {
        ...state,
        letterCode: action.letterCode,
        attachments: action.payload,
        loadingToRequest: false,
      };
    }

    case ActionTypes.UPLOAD_ATTACHMENT: {
      return {
        ...state,
        upLoadedAttachment: false,
      };
    }
    case ActionTypes.UPLOAD_ATTACHMENT_SUCCESS: {
      return {
        ...state,
        letterAttachmentUploadModel: [
          ...state.letterAttachmentUploadModel,
          {
            letterAttachmentId: action.payload.letterAttachmentId,
            fileName: action.payload.fileName,
          },
        ],
        upLoadedAttachment: true,
      };
    }
    case ActionTypes.CLEAR_ATTACHMENT: {
      return {
        ...state,
        letterAttachmentUploadModel: [],
      };
    }
    case ActionTypes.GET_Attachment_BY_ID: {
      return {
        ...state,
        downloadAttachment: null,
      };
    }

    case ActionTypes.FETCH_Attachment_BY_ID_SUCCESS: {
      return {
        ...state,
        downloadAttachment: action.payload,
      };
    }
    case ActionTypes.REMOVE_ATTACHMENT_SUCCESS: {
      const letterAttachmentFilter = (item: any) =>
        item.letterAttachmentId != action.payload.letterAttachmentId;
      const letterAttachmentModel = state.letterAttachmentUploadModel.filter(
        letterAttachmentFilter,
      );
      const attachFilter = (item: any) =>
        item.attachId != action.payload.letterAttachmentId;
      const attachment = state.attachments.filter(attachFilter);

      return {
        ...state,
        letterAttachmentUploadModel: letterAttachmentModel,
        attachments: attachment,
      };
    }
    case ActionTypes.GET_Attachment: {
      return {
        ...state,
        attachments: action,
        loadingToRequest: true,
      };
    }

    default:
      return state;
  }
};
